(function () {
  function money(value) {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0
    }).format(Math.max(0, value || 0));
  }

  function initMenu() {
    var button = document.querySelector('[data-tl-menu-toggle]');
    var menu = document.querySelector('[data-tl-mobile-nav]');
    if (!button || !menu) return;

    button.addEventListener('click', function () {
      var isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      menu.classList.toggle('is-open', !isOpen);
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        button.setAttribute('aria-expanded', 'false');
        menu.classList.remove('is-open');
      });
    });
  }

  function initCalculator() {
    var root = document.querySelector('[data-tl-calculator]');
    if (!root) return;

    var amount = root.querySelector('[data-tl-amount]');
    var purchase = root.querySelector('[data-tl-purchase]');
    var sale = root.querySelector('[data-tl-sale]');
    var result = root.querySelector('[data-tl-result]');

    function calculate() {
      var quantity = Math.max(0, parseFloat(amount.value) || 0);
      var purchasePrice = Math.max(0, parseFloat(purchase.value) || 0);
      var salePrice = Math.max(0, parseFloat(sale.value) || 0);
      result.textContent = money(quantity * Math.max(0, salePrice - purchasePrice));
    }

    [amount, purchase, sale].forEach(function (input) {
      input.addEventListener('input', calculate);
    });

    calculate();
  }

  function initBodyClass() {
    if (document.querySelector('.tl-site-header')) {
      document.body.classList.add('taplaunch-theme');
    }
  }

  function initCartPage() {
    document.querySelectorAll('main a[href="/collections/all"]').forEach(function (link) {
      link.setAttribute('href', '/collections/starterpacks');
    });

    if (window.location.pathname === '/cart') {
      document.body.classList.add('taplaunch-cart');
    }
  }

  function init() {
    initBodyClass();
    initCartPage();
    initMenu();
    initCalculator();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
